import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const logoClasses = {
  phrase: css`
    font-size: ${spacing(7)};
    line-height: ${cssTheme.fonts.heights.header.tight} !important; // заюзан title1, нужно перебить его типографику
    letter-spacing: ${cssTheme.fonts.spacings.header.regular} !important;
  `,
  qrPhrase: css`
    // TODO: Добавить цвет в cssTheme
    color: #A6A6A6;
  `,
  gap: css`
    margin-block-end: ${spacing(1.625)};
  `,
  logoContainer: css`
    margin-block-start: ${spacing(1.875)};
  `,
  arrow: css`
    inline-size: ${spacing(8.375)};
    block-size: ${spacing(5)};
    margin-inline-end: ${spacing(1.875)};
  `,
  logo: css`
    inline-size: ${spacing(30.25)};
    block-size: ${spacing(8.75)};
  `,
}
